import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import { NotificationService } from '@app/shared/services/notification.service';
import { TimeSince } from '@app/shared/utils/TimeSince'
import { io } from 'socket.io-client';

@Component({
    selector: 'nav-notification',
    templateUrl: './nav-notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.header-nav-item]': 'true'
    },
    providers: [
        NotificationService
    ],
})
export class NavNotificationComponent implements OnInit {
    
    asigedTable:any= this.auth.getTableName();
    clientName:any= this.auth.getClientName();
    userRole = this.auth.getUserRole();
    socket: any;
    notificationList = [];
    notificationIconMap = {
        0: '',
        1: 'feather icon-info',
        2: 'feather icon-check-circle',
        3: 'feather icon-x-circle'
    }

    notificationColorMap = {
        0: '',
        1: 'bg-primary',
        2: 'bg-success',
        3: 'bg-danger'
    }

    constructor(private notificationSvc: NotificationService,private auth: AuthService, private cdr: ChangeDetectorRef) {
        this.ngOnInit();
    }

    getTimeDistance(time: number) {
        return TimeSince(time)
    }
    
    ngOnInit(): void {
        if(this.userRole != 'Super Admin')
            this.getAllNotification();
        this.socket = io(this.auth.geturl());
        this.socket.on('new-lead', (data:any) => {
            if(this.userRole != 'Super Admin')
                this.getAllNotification();
        });
    }
    menuIsAllow(name:any){
        if(this.userRole == 'Admin' ||(this.userRole == 'Employee' && this.asigedTable.includes(this.clientName+'_'+name)))
            return true;
        else
            return false;
    }
    getAllNotification(){
        this.notificationList=[];
        this.auth.allNotification().subscribe((res:any)=>{
            if(res.length > 0)
            { 
                this.notificationList=[];
                for(var i=0; i < res.length; i++){
                    if(this.menuIsAllow(res[i].target))
                    {
                        // console.log(res[i])
                        this.notificationList.push(res[i]);
                    }
                }
                this.cdr.detectChanges();
                console.log(this.notificationList);
            }
            else{
                this.notificationList = [];
            }
        },(err:any)=>{
            console.log(err);
        })
    }
    updateNotification(id:any){
        this.auth.updateNotification(id).subscribe((res:any)=>{
            this.getAllNotification();
        },(err:any)=>{
            console.log(err);
        })
    }
    markAllRead(){
        this.auth.markAllRead(this.clientName).subscribe((res:any)=>{
            this.getAllNotification();
        },(err:any)=>{})
    }
}
